import { useBeneficiaries } from 'contexts/Beneficiaries';
import React from 'react';
import { useExportCsv } from 'contexts/ExportCsv';
import ExportStatusMessage from '../ExportStatusMessage';
import { TableFilters } from './TableFilters';
import TableHeader from './TableHeader';
import TableRow from './TableRow';
import TableSearch from './TableSearch';
import PaginationComponent from '../Pagination';
import { LoadingSkeleton } from '../LoadingSkeleton';

const TableBeneficiaries = () => {
  const { isEmpty, loading, totalPages } = useBeneficiaries();
  const { downloading } = useExportCsv();

  return (
    <>
      {downloading ? (
        <ExportStatusMessage />
      ) : (
        <div className="beneficiaries-table-wrapper" data-testid="test-table-beneficiaries">
          <TableSearch />
          <TableFilters />
          {loading && <LoadingSkeleton />}
          {!loading && !isEmpty && (
            <div className="container-table-beneficiaries">
              <table>
                <tbody>
                  <TableHeader />
                  <TableRow />
                </tbody>
              </table>
            </div>
          )}
          {!isEmpty && <PaginationComponent totalPages={totalPages} />}
        </div>
      )}
    </>
  );
};

export default TableBeneficiaries;
